'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

function getSessionId(): string {
  if (typeof window === 'undefined') return ''
  let sid = sessionStorage.getItem('_sid')
  if (!sid) {
    sid = Date.now().toString(36) + Math.random().toString(36).slice(2)
    sessionStorage.setItem('_sid', sid)
  }
  return sid
}

export default function PageTracker() {
  const pathname = usePathname()

  useEffect(() => {
    if (!pathname || pathname.startsWith('/admin')) return

    const userId = (() => {
      try {
        const token = localStorage.getItem('auth_token')
        if (!token) return null
        // Base64 토큰에서 user_id 파싱 (에러 시 null)
        const parts = token.split('.')
        const b64 = parts.length === 3 ? parts[1] : parts[0]
        let padded = b64.replace(/-/g, '+').replace(/_/g, '/')
        while (padded.length % 4) padded += '='
        const decoded = JSON.parse(Buffer.from(padded, 'base64').toString())
        return decoded?.user_id || null
      } catch { return null }
    })()

    fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: pathname, session_id: getSessionId(), user_id: userId }),
    }).catch(() => {})
  }, [pathname])

  return null
}
